/**
 * The PO number a "Request BOL from Stord" click should search with straight away, or `null`
 * when the deduction has none and the user has to be asked for one.
 *
 * Stord is looked up by order number, and the deduction's PO *is* that number, so a click with a
 * PO on the deduction goes to Stord immediately; the dialog is only for the case where there is
 * nothing to search with.
 */
export function stord_po_number_to_search(po_number: string | null | undefined): string | null {
  const trimmed = (po_number ?? "").trim()
  return trimmed.length > 0 ? trimmed : null
}
